import React from 'react'

export default function SiteLogo({ className = 'f5 mh2' }) {
  return <i className={`fas fa-feather logo ${className}`} />
}
